
import { handleActions, combineActions } from 'redux-actions'
import { updateStateAction } from './authenticate.actions'

const initialState = {
	userInfo: {} as any
}

export type AuthenticateState = Readonly<typeof initialState>


export default handleActions<any>({
	[combineActions(updateStateAction) as any]: (
		state, action
	) => {
		return Object.assign({}, state, { 
			userInfo: action.payload
		})
	}
}, initialState)